import React, { FC } from 'react';
import { getDecisionPieChartConfig } from '../getPieChartConfig';
import { villebaseH } from './villesChart.utils';
import { LazyReactChart } from '../LazyReactChart';
import { EntityChartItem } from '../components/EntityChartComponents';

type Props = {
  handleClick?: (wantToOpenInNewTab: boolean, index: number | null) => void;
  data: Array<number>;
  labels: Array<string>;
};

export const VillesChart: FC<Props> = ({
  data,
  labels,
  handleClick = () => {},
}) => {
  return (
    <EntityChartItem>
      {data.length > 0 && (
        <LazyReactChart
          config={getDecisionPieChartConfig({
            baseH: villebaseH,
            data,
            labels,
            handleClick,
          })}
        />
      )}
    </EntityChartItem>
  );
};
